import { z } from 'zod';
import { SourceRef } from './ask.js';
import { SynthesisSection } from './dossier.js';
/**
 * A saved brief snapshot (frontend spec §6.6).
 *
 * Briefs are immutable-ish snapshots of the synthesis at the time of
 * save: the analyst can update them later, but the captured `sections`
 * + `sources` no longer track the underlying entity. That's deliberate —
 * a shared brief link should never silently change after the principal
 * has read it.
 */
export const SavedBrief = z.object({
    id: z.string(),
    orgId: z.string(),
    ownerUid: z.string(),
    authorName: z.string().optional(),
    entityName: z.string(),
    entityNameFa: z.string().optional(),
    classification: z.string(),
    headline: z.string(),
    sections: z.array(SynthesisSection).default([]),
    sources: z.array(SourceRef).default([]),
    synthesisModel: z.string().optional(),
    synthesisGeneratedAt: z.string().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
